import { jumpToTarget } from '../helpers/jumpToTarget';

export function JumpLink(){
  document.addEventListener('DOMContentLoaded', () => {
    const jumplinks = document.querySelectorAll('.js-jumplink');
    jumplinks.forEach(jumplink => {
      jumplink.addEventListener('click', event => {
        event.preventDefault();
        const hrefValue = jumplink.getAttribute('href');
        jumpToTarget(document.querySelector(hrefValue))
      });
    });
  });
}



// WEBPACK FOOTER //
// ./src/ktu/js/components/JumpLink.js